import React, { useContext, useMemo } from 'react';
import connectionContext from '../context/connection/connectionContext';
import modalContext from '../context/modal/modalContext';
import walletConnections, { ClosableWallet } from '../web3/walletConnections';
import CustomModal from '../components/CustomModal';
import RiskDisclaimer from '../components/RiskDisclaimer';
import { ConnectWalletIcon, CrossIcon, WalletConnectorIcons } from '../assets/icons';
import { SupportedChains, SupportedConnectors } from '../config/constants';
import Eth from '@ledgerhq/hw-app-eth';
import { useWeb3React } from '@web3-react/core';
import { fox } from '../web3/connectors';

const ARBITRUM_SUPPORTED_WALLETS = [
    SupportedConnectors.METAMASK.toString(),
    SupportedConnectors.WALLET_CONNECT.toString(),
    SupportedConnectors.COINBASE.toString(),
    SupportedConnectors.NABOX.toString(),
    SupportedConnectors.FOX.toString(),
    SupportedConnectors.BITKEEP.toString(),
    SupportedConnectors.OKX.toString(),
];

const ConnectWalletModal: React.FC = () => {
    const { openModal, closeModal } = useContext(modalContext);
    const { chainId } = useWeb3React();
    const {
        activeConnector,
        activateWallet,
        disconnectWallet,
        handleDisconnect,
        setLedgerTransportAndResolve,
    } = useContext(connectionContext);

    const onClose = () => closeModal('connectWalletModal');

    const handleWalletClick = async (
        name: SupportedConnectors,
        connector: any | null
    ) => {
        activeConnector.name === name
            ? disconnectWallet()
            : activateWallet(name, connector);
    };

    const showDisconnect = useMemo(
        () => activeConnector.name && ClosableWallet.includes(activeConnector.name),
        [activeConnector.name]
    );

    //function for LedgerHQConnector to get the Path the user selects
    const getPath = (eth: Eth) => {
        return new Promise((resolve) => {
            setLedgerTransportAndResolve(eth, resolve);
            openModal('accountSelectorModal');
        });
    };

    return (
        <CustomModal modalName='connectWalletModal' className='connect-wallet-modal'>
            <div className='content'>
                <button type='button' onClick={onClose}>
                    <CrossIcon />
                </button>
                <ConnectWalletIcon />
                {showDisconnect ? (
                    <button className='disconnect' onClick={handleDisconnect}>
                        Disconnect Wallet
                    </button>
                ) : (
                    <>
                        <div className='title'>Connect Wallet</div>
                        <div className='wallet-connections'>
                            {Object.entries(walletConnections).map(
                                ([walletName, connector]) => {
                                    if (connector === fox && !(window as any).foxwallet) {
                                        return null;
                                    }
                                    if (
                                        chainId === SupportedChains.ARBITRUM_ONE &&
                                        !ARBITRUM_SUPPORTED_WALLETS.includes(walletName)
                                    ) {
                                        return null;
                                    }
                                    return (
                                        <button
                                            key={walletName}
                                            className={
                                                walletName === activeConnector.name
                                                    ? 'active'
                                                    : undefined
                                            }
                                            disabled={
                                                activeConnector.name ===
                                                SupportedConnectors.FOX
                                            }
                                            onClick={() =>
                                                handleWalletClick(
                                                    walletName as SupportedConnectors,
                                                    walletName ===
                                                        SupportedConnectors.LEDGER
                                                        ? connector(getPath)
                                                        : walletName ===
                                                              SupportedConnectors.WALLET_CONNECT ||
                                                          walletName ===
                                                              SupportedConnectors.UAUTH
                                                        ? connector(
                                                              chainId as SupportedChains
                                                          )
                                                        : connector
                                                )
                                            }
                                        >
                                            <div className='icon-container'>
                                                {WalletConnectorIcons[walletName]}
                                            </div>
                                            {walletName}
                                        </button>
                                    );
                                }
                            )}
                        </div>
                        <RiskDisclaimer />
                    </>
                )}
            </div>
        </CustomModal>
    );
};

export default ConnectWalletModal;
